import Style from "./Style.module.scss";
import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { AppState } from "../state";
import { VolumeAction} from "../state/volume";

import volumemaxselectedsvg from "../../../static/volume/volumemaxselected.svg"
import volumemaxsvg from "../../../static/volume/volumemax.svg"
import volumemiddleselectedsvg from "../../../static/volume/volumemiddleselected.svg"
import volumemiddlesvg from "../../../static/volume/volumemiddle.svg"
import volumeminselectedsvg from "../../../static/volume/volumeminselected.svg"
import volumeminsvg from "../../../static/volume/volumemin.svg"
import Overlay from "react-bootstrap/Overlay";
import {ClickOuterDiv} from "../../Hook/useClickOuter";
import {SpeedAction} from "../state/speed";
import rectanglesvg from "../../../static/rectangle.svg";
import { storageSet, storageGet } from "../../../utils/storage";

/**
 *     let src = selected ? "/volume/volumemaxselected.svg" : "/volume/volumemax.svg";
 *     if (volume < 0.75)
 *         src = selected ? "/volume/volumemiddleselected.svg" : "/volume/volumemiddle.svg";
 *     if (volume < 0.25)
 *         src = selected ? "/volume/volumeminselected.svg" : "/volume/volumemin.svg";
 */



const StylePropertyName = "--background-size";



export const Volume = () => {
    const [selected, setSelected] = useState(0);
    const [mouseDown, setMouseDown] = useState(false);
    const volume = useSelector((app: AppState) => app.volume);
    const dispatch = useDispatch();
    const buttonRef = useRef<HTMLInputElement| null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const timeoutRef = useRef<any>(null);
    const progressRef = useRef<HTMLInputElement|null>(null);
    let src = selected ? volumemaxselectedsvg : volumemaxsvg;
    if (volume < 0.75)
        src = selected ? volumemiddleselectedsvg : volumemiddlesvg;
    if (volume < 0.25)
        src = selected ? volumeminselectedsvg : volumeminsvg;

    const imgSrc = <img alt={"volume"} src={src}/>;


    useEffect(() => {
        if (inputRef.current) {
            const v = `${(volume * 100)}%`;
            const val = inputRef.current.style.getPropertyValue(StylePropertyName);
            if (val !== v) {
                inputRef.current.style.setProperty(StylePropertyName, v)
            }
        }
    }, [volume, selected]);

    useEffect(() => {
        if (!selected)
            setMouseDown(false);
    }, [selected]);

    const onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {

        const bounds = e.currentTarget.getBoundingClientRect();
        const max = bounds.height //Get width element
        const pos = e.clientY - bounds.top;
        let dual = 1 - (pos / max); // Round %
        if (dual < 0.02)
            dual = 0;
        if (dual > 0.98)
            dual = 1;

        dispatch<VolumeAction>({
            type: "Volume",
            payload: dual
        });
    }

    return <div ref={buttonRef} className={Style.Volume} onMouseOver={_ => {
        clearTimeout(timeoutRef.current);
        setSelected(1);
    }} onMouseLeave={_ => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=> {
            setSelected(0);
        }, 2100);
    }}>
        <button className={`${Style.Button} ${Style.VolumeButton}`} onClick={_ => {
            if (volume > 0) {
                if (!("ontouchstart" in window)) {
                    dispatch<VolumeAction>({
                        payload: 0,
                        type: "Volume"
                    });
                    storageSet("savedVolume", `${volume}`);
                }
            } else {
                if (!("ontouchstart" in window)) {

                    const v =storageGet('savedVolume');
                    let newVolume = parseFloat(v ?? '');
                    if (isNaN(newVolume) || newVolume < 0 || newVolume > 1)
                        newVolume = 1;
                    dispatch<VolumeAction>({
                        payload: newVolume,
                        type: "Volume"
                    });
                }
            }
            setSelected(c => c + 1);
        }}>
            {imgSrc}
        </button>
        <Overlay target={buttonRef.current} show={!!selected} placement={"top"}>
            {({
                  placement: _placement,
                  arrowProps: _arrowProps,
                  show: _show,
                  popper: _popper,
                  hasDoneInitialMeasure: _hasDoneInitialMeasure,
                  ...props
              }) => (
                <div
                    key={"own"}
                    {...props}
                    style={{
                        position: 'absolute',
                        zIndex:150,
                        padding: '10px 10px',
                        borderRadius: 10,
                        ...props.style,
                        transform: (props.style.transform ?? "") + " translate(0, -15px)"
                    }}
                    className={`${Style.MenuBackground} ${Style.menu}`}
                >
                    <ClickOuterDiv onOutClick={() => {
                        setSelected(c => {
                            c = c - 1;
                            if (c < 0)
                                c = 0;
                            return c;
                        });
                    }}>
                        <div className={`${Style.vertical}`} onMouseDown={e => {
                            setMouseDown(true);
                            onMouseMove(e);

                        }} onMouseMove={(ev) => {
                            if (mouseDown)
                                onMouseMove(ev);
                        }} onMouseUp={e=>{
                            setSelected(c => c + 1);
                            setMouseDown(false);
                        }}>
                            <div ref={progressRef} className={`${Style.progressBar} progress-bar-info`} role="progressbar"
                                 aria-valuenow={volume} aria-valuemin={0}
                                 aria-valuemax={1} style={{height: `${(1-volume) * 100}%`}}>
                            </div>
                        </div>

                    </ClickOuterDiv>
                    <img src={rectanglesvg} alt={""} className={Style.Rectangle}/>
                </div>
            )}
        </Overlay>
        {/*
        <br/>
        <input style={{display: selected ? "block" : "none"}} ref={inputRef} className={`${Style.Range} form-range`} type={"range"} min={0} max={1} value={volume}
               step={0.1} onChange={x => {
            x.target.style.setProperty(StylePropertyName, `${(parseFloat(x.target.value) * 100)}%`);
            dispatch<VolumeAction>({
                type: "Volume",
                payload: parseFloat(x.target.value)
            });
        }}/>
           */}
    </div>
}